// tuning/town.ts (M0-T06, §7.2)
import type { TuningBank } from '../schema/tuning';

export default {
  plots: 10, plotW: 7, plotH: 6, houseW: 3, houseH: 3, maxResidents: 10, startVillagers: 4, archiveDeleteDays: 90,
  maxFoundedPerUser: 5 /* D-46 */, inviteDefaultHours: 72, inviteMaxHours: 720, inviteMaxUses: 50,
  inviteHourOptions: [24, 72, 168, 720], inviteUseOptions: [1, 5, 10],   // rev 7 item 30: the invite form's choices
  nameMinChars: 2, nameMaxChars: 16, townNameMaxChars: 20, moveInFee: 5000, interactRange: 1.5, doorRange: 2.5,
  dropBoxRange: 2,
} as const satisfies TuningBank;
